<template>
    <div
        :class="{
            darkblue: activeStep === number,
            green: activeStep > number,
            gray: activeStep < number || final,
        }"
        class="font16 pointer numberHeaderContainer"
        style="line-height: 25px;"
    >
        <span v-if="final || number < activeStep" class="numberHeader">
            <font-awesome-icon icon="check" size="xs" />
        </span>

        <span
            v-else
            class="numberHeader"
            :class="{ darkblueBullet: activeStep === number }"
        >

            {{ numberFake }}
        </span>

      <div
          :class="{
                darkblue: activeStep === number,
                green: activeStep > number,
                gray: activeStep < number || final,
            }"
          class="numberHeaderSubtitle"
      >
        <span>{{ title }}
        <div v-if="number < activeStep" style="display: inline-block"> - <u>Wijzigen</u></div></span
        >
      </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faArrowDown,
    faCheck,
    faSpinner,
} from '@fortawesome/free-solid-svg-icons'

library.add(faSpinner)
library.add(faArrowDown)
library.add(faCheck)

export default {
    name: 'NumberHeaderSmall',
    props: {
        number: Number,
        numberFake: Number,
        title: String,
        subtitle: String,
        loading: Boolean,
        activeStep: Number,
        final: Boolean,
    },
}
</script>

<style lang="scss" scoped>
.numberHeaderContainer {
    > div {
        > span {
            color: #7f8386 !important;
            font-size: 9pt !important;
          line-height: 10px;
            background-color: transparent !important;
        }
    }

    .numberHeader {
        display: block;
        border-radius: 50%;
        color: #fff;
        height: 25px;
        width: 25px;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        right: 10px;
        top: 10px;
        float: left;
        margin-right: 8px;
        line-height: 25px;
    }

    .numberHeaderSubtitle {
        max-width: 90%;
        display: inline-block;
      u {
        font-size: 9px;
        color: #7f8386 !important;
      }
    }

    .darkblueBullet {
        color: #ffffff;
        background-color: #2078b3 !important;
    }
}

@media only screen and (max-width: 900px) {
  .numberHeaderContainer {
    margin-left: 0px;
    .numberHeaderSubtitle {
      display: none;
    }
  }
}
</style>